import { Scanner } from "@credenza3/scanner-lib";

export type ScannerLib = Scanner;
export type ScannerEventName = string;
export type ScannerEventsMap = {
  CAPTURE: ScannerEventName;
  CANCEL: ScannerEventName;
  ERROR: ScannerEventName;
};

export const SCANNER_TARGET_ID = "cpuiScanner";
export const CRED_SCANNER_TARGET_ID = "cpuiCredScanner";

export const createScanner = async (
  targetId: string,
): Promise<{ scanner: ScannerLib; events: ScannerEventsMap }> => {
  const scanner = new Scanner({ target: `#${targetId}` });
  const events = Scanner.events as ScannerEventsMap;
  return { scanner, events };
};

export const getScannerErrorMessage = (err: { message?: string } | string) =>
  typeof err === "string" ? err : err?.message;

export const setupScanner = <CapturePayload = unknown>(
  scanner: Scanner,
  events: ScannerEventsMap,
  handlers: {
    onCapture?: (payload: CapturePayload) => void | Promise<void>;
    onCancel?: () => void;
    onError?: (err: { message?: string } | string) => void;
  },
) => {
  const on = scanner.on.bind(scanner) as (event: ScannerEventName, cb: unknown) => void;
  if (handlers.onCapture) on(events.CAPTURE, handlers.onCapture);
  if (handlers.onCancel) on(events.CANCEL, handlers.onCancel);
  if (handlers.onError) on(events.ERROR, handlers.onError);
};
